"use strict";

exports.random = Math.random;



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-random/src/Control/Monad/Eff/Random.js
// module id = 92
// module chunks = 0